// src/v2/pages/Reports/ReportMCRF.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportMCRF } from '../../hooks/useReportMCRF';
import { ReportMCRFModule } from '../../components/modules/Reports/ReportMCRF/ReportMCRFModule';

const ReportMCRF = ({ isHideSideMenu }) => {
  const reportHook = useReportMCRF();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportMCRFModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportMCRF;